export enum FinalDeliveryType {
  NO_DELIVERY = 'NO_DELIVERY',
  AGGREGATOR_DELIVERY = 'AGGREGATOR_DELIVERY',
  KITOPI_OWN_DELIVERY = 'KITOPI_OWN_DELIVERY',
}
